export default function normalize(data, typeProperty) {
  return data.reduce((acc, item) => {
    const key = item[typeProperty];
    acc[key] = item;
    return acc;
  }, {});
}
